import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// components
import CardLogin from "components/Cards/Auth/CardLogin.js";
import FooterAuth from "components/Footers/Auth/FooterAuth";
// texts
import cardregister from "_texts/auth/cards/cardregister.js";
import footerauth from "_texts/auth/footers/footerauth.js";

const Register = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <>
      <main>
        <section className="relative w-full h-full py-40 min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-black bg-no-repeat bg-full"
            style={{
              backgroundImage:
                "url(" + require("assets/img/bg-agentwire2.png").default + ")",
            }}
          ></div>
          <div className="container mx-auto px-4 h-full">
            <div className="flex content-center items-center justify-center h-full">
              <div className="w-full lg:w-5/12 px-4">
                <CardLogin {...cardregister} />
              </div>
            </div>
          </div>
          <FooterAuth {...footerauth} />
        </section>
      </main>
    </>
  );
}

export default Register